import React from 'react';
import Swal from 'sweetalert2';
import { atuatualizarLogUpSell, cadastrarLogUpSell } from '../../services/upSell';
import { showMessageAlert, showMessageSuccess } from '../others/toastr';
import { BuscarCep } from '../../modulos/Cep';

export const statusEnum = {
    recusado: 'RECUSADO',
    migrado: 'MIGRADO',
    liberado: 'LIBERADO'
};

export const cadastrarEAtualizarContratosUpsel = async (contrato, vendedor) => {
    const { inscricao, iniciadoUpsell, status } = contrato;
    const { tipoColaborador, codigoVendedor } = vendedor;

    const infoVendedor = {
        inscricao,
        tipo: tipoColaborador,
        codigo: codigoVendedor
    };

    if (iniciadoUpsell === false) {
        return await cadastrarLogUpSell(infoVendedor);
    } else if (status === statusEnum.liberado) {
        return await atuatualizarLogUpSell(infoVendedor);
    }
};

// Funções do Modal
export const atualizarStatusNoFluxo = async (bodyRequest, body) => {
    const response = await atuatualizarLogUpSell(bodyRequest, body);

    return response;
};

export const formatarEmDinheiro = number => number === false ? 'N/A' : `R$ ${number?.toFixed(2)}`;

export const formatarDetalhesComparacao = info => {
    const tipoParentesco = Array.isArray(info.parentescos) ? info.parentescos.join(', ') : '';

    const valorDepMedioOUMaior = info.valorDepMedia ? info.valorDepMedia : info.valorMaior;

    const renderCampoComAsterisco = (label, valor) => (
        <li>
            {info.planoAtual === false && <span style={{ color: 'red' }}>* </span>}
            {label}: <span className="valuesScrollpanel">{valor}</span>
        </li>
    );

    return (
        <ul>
            <li>Descrição: <span className="valuesScrollpanel">{info.descricao}</span></li>
            <li>Subgrupo: <span className="valuesScrollpanel">{info.subgrupo}</span></li>
            {renderCampoComAsterisco('Valor Mensal', formatarEmDinheiro(info.mensalidade))}
            {renderCampoComAsterisco('Cremação', info.cremacao)}
            <li className="dependentesTitulo">Dependentes:</li>
            <ul className="dependentesDetalhes">
                {renderCampoComAsterisco('Quantidade', info.depQuantidadeTotal)}
                {renderCampoComAsterisco('Parentesco', tipoParentesco)}
                {renderCampoComAsterisco(`Dependentes até ${info.idadeDepMenor} Anos`, info.quantidadeDepMenor ?? 'N/A')}
                {renderCampoComAsterisco(`Dependentes até ${info.idadeDepMaior} Anos`, info.quantidadeMaior ?? 'N/A')}
                {renderCampoComAsterisco('Sem valor Adicional', info.semValorAdicional)}
                {renderCampoComAsterisco(`Valor Dependentes até ${info.idadeDepMenor} Anos`, formatarEmDinheiro(info.valorDepMenor ?? false))}
                {renderCampoComAsterisco(`Valor Dependentes acima de ${info.idadeDepMaior - 1} Anos`, formatarEmDinheiro(valorDepMedioOUMaior ?? false))}
                {renderCampoComAsterisco('Parentesco Pet', 'Conforme disponibilidade da região')}
            </ul>
        </ul>
    );
};

const validarCepValido = async cep => {
    try {
        if (cep.length !== 8) {
            showMessageAlert('CEP inválido!', 'Insira o cep correto!', 'toast-top-center');

            return false;
        }

        const resultCep = await BuscarCep(cep);

        if (resultCep.erro) {
            showMessageAlert('CEP inválido!', 'Insira o cep correto!', 'toast-top-center');

            return false;
        }

        return resultCep;
    } catch (error) {
        return false;
    }
};

export const validarNovoCep = async (CEPResid, fecharCardCep) => {
    const cepFormatado = CEPResid.replace(/\D/g, '');

    const cepValidado = await validarCepValido(cepFormatado);

    if (cepValidado) {
        const dadosCepEditado = {
            CodigoIbge: cepValidado.ibge,
            Residencia: cepValidado.logradouro,
            Bairro: cepValidado.bairro,
            Cidade: cepValidado.localidade,
            Uf: cepValidado.uf,
            CEPResid: cepFormatado
        };

        showMessageSuccess('Sucesso', 'Cep selecionado com sucesso!', 'toast-top-center');

        fecharCardCep();

        return dadosCepEditado;
    }
};

export const converterValorMonetarioParaNumero = valorMonetario => {
    let valorNumerico = valorMonetario.replace(/[^\d,]/g, '');

    valorNumerico = valorNumerico.replace(',', '.');

    return parseFloat(valorNumerico);
};

export const mensagemSweetAlertWarning = msg => (
    Swal.fire({
        position: 'center',
        icon: 'warning',
        confirmButtonColor: '#0d730d',
        text: msg,
        showConfirmButton: true,
        timer: 9000
    })
);
